import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, Grid,TableCell, TableContainer, TableHead, TableRow, Paper,
  TablePagination, TextField, InputAdornment, IconButton, Box, Typography, CircularProgress, Button
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import axios, { decryptData, encryptData } from '../Axiosinstance';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import { Link, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FinHeader from '../Finance/Fheader';
import { buttonBackgroundColor } from '../common';

const IntakeDetailsTable = () => {
  const { batchId } = useParams();
  // alert(batchId)
  const [intakeDetails, setIntakeDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(true);


  useEffect(() => {

    axios.get(`intake-details/batch/${decryptData(decodeURIComponent(batchId))}`)
      .then((response) => {
        setIntakeDetails(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, [batchId]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // const handlePageChange = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleRowsPerPageChange = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  const filteredDetails = intakeDetails.filter(detail =>
    detail.intakeId.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedFilteredDetails = filteredDetails.sort((a, b) => {
    // Extract the numeric part after "DMEE-" and compare them
    const intakeIdA = a.intakeId ? a.intakeId.split('-')[1] : 0;  // Get the number part after the dash (e.g., 20 from DMEE-20)
    const intakeIdB = b.intakeId ? b.intakeId.split('-')[1] : 0;

    // Convert the numeric parts to integers for comparison
    return parseInt(intakeIdB) - parseInt(intakeIdA);  // For descending order
  });


  const exportAllDataToExcel = () => {
    if (filteredDetails.length === 0) {
      alert("No data to export!");
      return;
    }

    // Prepare all data
    const excelData = filteredDetails.map(detail => ({
      "Intake ID": detail.intakeId,
      "Start Date": new Date(detail.startDate).toLocaleDateString("en-GB"),
      "End Date": new Date(detail.endDate).toLocaleDateString("en-GB"),
      "Manage": "View Batch",
      "Curriculum Manages": "View Materials",
    }));

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Style the headers (bold)
    const range = XLSX.utils.decode_range(worksheet['!ref']); // Get the range of the sheet
    const excel = 0; // The header is at the 0th row (indexing starts from 0)
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_col(C) + excel; // Address of header cells (row 0)
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: { bold: true },  // Make the header text bold
          alignment: { horizontal: "center" }, // Center align header text
        };
      }
    }


    // Set column widths
    worksheet["!cols"] = [
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
      { wch: 25 },
    ];

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "All Data");

    // Convert to binary and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Intake_Details_Data.xlsx");
  };

  const usertype = localStorage.getItem("usertype");
  return (

    <>  <div>
    {usertype === '3' || usertype === '4' ? (
      <Header />
    ) : usertype === '6' ? (
      <FinHeader />
    ) : (
      null
    )}

  </div>
      <Box p={2} display="flex" flexDirection="column" alignItems="center" style={{ marginTop: '-50px' }}>


        <Box mt={3} mb={2}>
          <Typography variant="h4" align="center" gutterBottom style={{fontWeight:'bolder'}}>
            Batches Details
          </Typography>
        </Box>
        <Box
          sx={{
            position: 'fixed', // Keeps it in place
            top: '100px', // Fixed distance from the bottom
            left: '20px', // Fixed distance from the right
            zIndex: 1000 // Ensures it's above other content
          }}
        >

        </Box>
        <Paper elevation={3} style={{ width: '80%', maxWidth: '1200px' }}>
        <Box mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <TextField
                  placeholder="Search by Intake ID"
                  variant="outlined"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Button
                  style={{
                    backgroundColor: buttonBackgroundColor,
                    color: 'white',
                  }}
                  onClick={exportAllDataToExcel}
                  fullWidth
                  sx={{ height: '100%' }}
                >
                  Download Excel
                </Button>
              </Grid>
            </Grid>
          </Box>
          <TableContainer component={Paper} style={{
            boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
            borderRadius: '8px',
            maxHeight: '500px',  // Set a max height for the container
            overflowY: 'auto'   // Enable vertical scrolling for the table body
          }}>
            {loading ? (
              <Box display="flex" justifyContent="center" p={3}>
                <CircularProgress />
              </Box>
            ) : (
              <Table>
                <TableHead>
                  <TableRow style={{
                    backgroundColor: '#f5f5f5',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1 // Ensure it stays above the table body when scrolling
                  }}>
                    <TableCell><strong>Intake ID</strong></TableCell>
                    <TableCell><strong>Start Date</strong></TableCell>
                    <TableCell><strong>End Date</strong></TableCell>
                    <TableCell><strong>Manage</strong></TableCell>
                    {usertype !== '6' && (
                      <TableCell style={{ width: '20%' }}> <strong> Curriculum Manages</strong></TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedFilteredDetails.length > 0 ? (
                    sortedFilteredDetails
                      // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((detail) => (
                        <TableRow key={detail.id}>
                          <TableCell>{detail.intakeId}</TableCell>
                          <TableCell>
                            {new Date(detail.startDate).toLocaleDateString("en-GB")}
                          </TableCell>
                          <TableCell>
                            {new Date(detail.endDate).toLocaleDateString("en-GB")}
                          </TableCell>

                          <TableCell>
                            <Link to={`/Managebatches/${encodeURIComponent(encryptData(detail.batchId))}/${encodeURIComponent(encryptData(detail.intakeId))}`} style={{ textDecoration: 'none' }}>
                              View Batch
                            </Link>
                          </TableCell>
                          {usertype !== '6' && (
                            <TableCell>{detail.contents}<Link to={`/Managec/${detail.batchId}/${detail.intakeId}`} style={{ textDecoration: 'none' }}>
                              View Materials
                            </Link></TableCell>
                          )}
                          {/* <TableCell>{detail.batchId}</TableCell> */}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        <Typography variant="body1" color="textSecondary">
                          No results found.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            )}
          </TableContainer>
          {/* <TablePagination
          component="div"
          count={filteredDetails.length}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
          rowsPerPageOptions={[5, 10, 25]}
        /> */}
        </Paper>
      </Box>

    </>
  );
};

export default IntakeDetailsTable;
